import React from 'react';
import { ThankYouPage } from './components/ThankYouPage';
export function App() {
  return <ThankYouPage data-id="element-0" />;
}